import {
  Beneficiary,
  EarlyAccountStateRegulation,
  FundingSourceInfo,
  LinkedAccount,
  RecurrenceFrequency,
  User,
} from 'generated/types'

export type EarlyAccount = {
  beneficiaryId: string
  id: string
  currentBalance: {
    value: number
  }
  beneficiary: {
    id: string
    firstName: string
    hasSsn: boolean
  }
}

export type AgeOption = {
  label: string
  value: string
}

export type EarlyChild = {
  name: string
  dob: string
  id: string
  ageOfTermination?: number
}

export type AllBeneficiaryAccounts = {
  beneficiaries: Beneficiary[]
  user: User
  fundingSourceInfo: FundingSourceInfo
  linkedAccounts: LinkedAccount[]
}

export type RecurringSettings = {
  amount: number
  frequency: RecurrenceFrequency
  day: number
}

export type RecurringSettingsForBeneficiary = {
  beneficiaryId: string
  recurringInvestmentSettings: RecurringSettings
}

export type AllRecurring = {
  investmentAccountsByUserId: RecurringSettingsForBeneficiary[]
}

export type EarlyAccountStateRegulationData = {
  earlyAccountStateRegulation: EarlyAccountStateRegulation
}

export enum EarlyQueryStringParams {
  initalOnboarding = 'initialOnboarding',
  resumeOnboarding = 'resumeOnboarding',
  moneyMovement = 'moneyMovement',
  isRegistrationFlow = 'isRegistrationFlow',
}
